// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__fXlr2","description":"PatientConsentPreview_description__2Z1Ut"};